var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"longerFade"}},[(_vm.showComponent)?_c('div',{staticClass:"introduction"},[_c('canvas',{ref:"canvas"}),_vm._v(" "),_c('transition',{attrs:{"name":"fade"},on:{"after-enter":_vm.afterWhiteFade,"enter":_vm.whiteFade}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.fadeToWhite),expression:"fadeToWhite"}],staticClass:"white"})])],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-365d1754","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Introduction.vue
// module id = B3ld
// module chunks = 1